/** Give existing inspector fields transactional undo without coupling each
 * input to a particular document shape. Button actions retain their own undo. */
export default function EditFields({ store, children, ...props }) {
  return <div {...props} onFocusCapture={e => {
    if (e.target.matches('input:not([type=file]), select, textarea')) store.beginEdit(e.target);
  }} onBlurCapture={e => {
    if (e.target.matches('input, select, textarea')) store.endEdit();
  }}>{children}</div>;
}
